<template>
  <div v-if="getPermission.yardQc.view">
    <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <h3>Downgrade Pictures</h3>
        <view-image :key="p" v-for="p in currentPictures.downgradeQcPics" :src="p"/>
        <download-pictures-button v-if="currentPictures.downgradeQcPics.length > 0" :pics="currentPictures.downgradeQcPics"/>

        <h3>Moisture Pictures</h3>
        <view-image :key="p" v-for="p in currentPictures.moistureQcPics" :src="p"/>
        <download-pictures-button v-if="currentPictures.moistureQcPics.length > 0" :pics="currentPictures.moistureQcPics"/>

        <h3>Rebale and Dispose Pictures</h3>
        <view-image :key="p" v-for="p in currentPictures.rebalesAndDisposeQcPics" :src="p"/>
        <download-pictures-button v-if="currentPictures.rebalesAndDisposeQcPics.length > 0" :pics="currentPictures.rebalesAndDisposeQcPics"/>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="isPictureModalShowing = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>


    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-60 md-small-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.deliveryFrom" @keyup.enter="doSearch">
                  <label>Delivery Date</label>
                </datepicker>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.deliveryTo" @keyup.enter="doSearch">
                  <label>To</label>
                </datepicker>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <auto-complete-master-data-multiple-select
                        label="End Outlet"
                        group="EndOutlet"
                        v-model="searchRequest.endOutletIds">
                </auto-complete-master-data-multiple-select>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-40 md-small-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <md-field>
                  <label>Created By</label>
                  <md-input v-model="searchRequest.createdBy" @keyup.enter="doSearch"/>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <md-field>
                  <label>Scale Ticket </label>
                  <md-input v-model="searchRequest.scaleTicket" @keyup.enter="doSearch"/>
                </md-field>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-60 md-small-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>Store</label>
                  <md-input v-model="searchRequest.storeIdFrom" @keyup.enter="doSearch"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>To</label>
                  <md-input v-model="searchRequest.storeIdTo" @keyup.enter="doSearch"/>
                </md-field>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-40 md-small-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <master-data-select
                        label="QC Status"
                        v-model="searchRequest.qcStatus"
                        :options="qcStatusOptions"
                />
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-60 md-small-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <calling-api :paths="['/api/w/loads/updateQcStatus','/api/w/yardQc/update','/api/w/excel/generate']" v-if="getPermission.yardQc.edit">
                  <md-button :disabled="!canConfirm" class="md-raised" @click="doConfirm">Confirm</md-button>
                  <md-button :disabled="!canReCheck" class="md-raised" @click="doReCheck">Recheck</md-button>
                  <md-button :disabled="!canSave" class="md-raised" @click="doSave">Save</md-button>
                  <md-button :disabled="!canDownload" class="md-raised" @click="doDownload">Download</md-button>
                  <md-checkbox v-model="filterUpdatedToSapFail" v-if="getRole.isAcnIT">
                    Show only update to SAP failed
                  </md-checkbox>
                </calling-api>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-40 md-small-size-100">

            <calling-api path="/api/w/yardQc">
              <md-card-actions>
                <md-button class="md-primary md-raised" @click="doSearch">Search</md-button>
                <md-button class="md-raised" @click="clearSearch">Clear</md-button>
              </md-card-actions>
            </calling-api>

          </div>
        </div>
      </md-card-content>

    </md-card>

    <pagination :items="getItemsToDisplay">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2" v-if="getPermission.yardQc.edit">
                      <md-checkbox v-model="allItemsSelected" @change="handleAllItemSelectedChanged">
                      </md-checkbox>
                    </th>
                    <th class="header-cell w5">Delivery End Date</th>
                    <th class="header-cell w5">EndOutlet</th>
                    <th class="header-cell w5">Load ID</th>
                    <th class="header-cell w4">Scale Ticket</th>
                    <th class="header-cell w4">BOL</th>
                    <th class="header-cell w4">Store</th>
                    <th class="header-cell w4">Moisture count</th>
                    <th class="header-cell w4">Moisture %</th>
                    <th class="header-cell w4">Downgrade count</th>
                    <th class="header-cell w4">Grade</th>
                    <th class="header-cell w4">Rebale count</th>
                    <th class="header-cell w4">Disposal count</th>
                    <th class="header-cell w4">Moisture Remark</th>
                    <th class="header-cell w4">Downgrade Remark</th>
                    <th class="header-cell w4">Rebales Remark</th>
                    <th class="header-cell w4">Photo Linked</th>
                    <th class="header-cell w7">Load QC Check Status</th>
                    <th class="header-cell w5">Create By</th>
                    <th class="header-cell w5">Create Date</th>
                    <th class="header-cell w5">Create Time</th>
                    <th class="header-cell w5">Change Person</th>
                    <th class="header-cell w5">Change Date</th>
                    <th class="header-cell w5">Change Time</th>
                    <th v-if="getRole.isAcnIT" class="header-cell w6">Updated to SAP</th>
                    <th v-if="getRole.isAcnIT" class="header-cell w6">Updated to SAP Date</th>
                    <th v-if="getRole.isAcnIT" class="header-cell w15">Updated to SAP message</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body" @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                  <tr v-for="item in pageItems">
                    <td class="body-cell w2" v-if="getPermission.yardQc.edit">
                      <md-checkbox :disabled="item.qcStatus === 'Y'" v-model="item.selected"/>
                    </td>
                    <td class="body-cell w5">{{item.deliveryEndDate | date}}</td>
                    <td class="body-cell w5">
                      <master-data-display group="EndOutlet" :tag-id="item.endOutletId"/>
                    </td>
                    <td class="body-cell w5">{{item.loadId}}</td>
                    <td class="body-cell w4">{{item.scaleTicket}}</td>
                    <td class="body-cell w4">{{item.bolNo}}</td>
                    <td class="body-cell w4">{{item.storeId}}</td>
                    <td class="body-cell w4">
                      <template v-if="item.qcStatus === 'C'">
                        <md-field>
                          <md-input type="number" v-model="item.moistureCount"/>
                        </md-field>
                      </template>
                      <template v-else>{{item.moistureCount}}</template>
                    </td>
                    <td class="body-cell w4">
                      <template v-if="item.qcStatus === 'C'">
                        <md-field>
                          <md-input type="number" v-model="item.moisturePercentage"/>
                        </md-field>
                      </template>
                      <template v-else>{{item.moisturePercentage}}</template>
                    </td>
                    <td class="body-cell w4">
                      <template v-if="item.qcStatus === 'C'">
                        <md-field>
                          <md-input type="number" v-model="item.downgradeCount"/>
                        </md-field>
                      </template>
                      <template v-else>{{item.downgradeCount}}</template>
                    </td>
                    <td class="body-cell w4">
                      <template v-if="item.qcStatus === 'C'">
                        <md-field>
                          <md-input type="number" v-model="item.grade"/>
                        </md-field>
                      </template>
                      <template v-else>{{item.grade}}</template>
                    </td>
                    <td class="body-cell w4">
                      <template v-if="item.qcStatus === 'C'">
                        <md-field>
                          <md-input type="number" v-model="item.rebaleCount"/>
                        </md-field>
                      </template>
                      <template v-else>{{item.rebaleCount}}</template>
                    </td>
                    <td class="body-cell w4">
                      <template v-if="item.qcStatus === 'C'">
                        <md-field>
                          <md-input type="number" v-model="item.disposeCount"/>
                        </md-field>
                      </template>
                      <template v-else>{{item.disposeCount}}</template>
                    </td>
                    <td class="body-cell w4">{{item.moistureRemark}}</td>
                    <td class="body-cell w4">{{item.downgradeRemark}}</td>
                    <td class="body-cell w4">{{item.rebalesRemark}}</td>
                    <td class="body-cell w4">
                      <template v-if="item.photoLinks.length > 0">
                        <a href="" @click.prevent="toggleItemPhoto(item)">{{item.photoLinks.length}} photos</a>
                      </template>
                      <template v-else>
                        <span>0 photos</span>
                      </template>
                    </td>
                    <td class="body-cell w7">{{item.qcStatus}}</td>
                    <td class="body-cell w5">{{item.createdBy}}</td>
                    <td class="body-cell w5">{{item.createdAt | date}}</td>
                    <td class="body-cell w5">{{item.createdAt | time}}</td>
                    <td class="body-cell w5">{{item.updatedBy}}</td>
                    <td class="body-cell w5">{{item.updatedAt | date}}</td>
                    <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    <td v-if="getRole.isAcnIT" class="body-cell w6">{{item.updatedToSap}}</td>
                    <td v-if="getRole.isAcnIT" class="body-cell w6">{{item.updatedToSapAt | date}} {{item.updatedToSapAt | time}}</td>
                    <td v-if="getRole.isAcnIT" class="body-cell w15">{{item.updatedToSapMessage}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>
</style>

<script>
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import _ from 'underscore';
  import toGenerateExcelRequest from '../utils/excel';

  const getInitSearchRequest = () => {
    return {
      deliveryFrom: null,
      deliveryTo: null,
      endOutletFrom: null,
      endOutletTo: null,
      storeIdFrom: null,
      storeIdTo: null,
      createdBy: null,
      scaleTicket: null,
      qcStatus: "C",
      endOutletIds: [],
    };
  };

  export default {
    data: () => ({
      qcStatusOptions: [
        {
          id: '',
          name: 'N/A',
        },
        {
          id: 'C',
          name: 'Completed',
        },
        {
          id: 'Y',
          name: 'Confirmed',
        }
      ],
      yardQc: [],
      searchRequest: getInitSearchRequest(),
      currentPictures: {
        downgradeQcPics: [],
        moistureQcPics: [],
        rebalesAndDisposeQcPics: [],
      },
      isPictureModalShowing: false,
      allItemsSelected: false,
      filterUpdatedToSapFail: false,
    }),
    computed: {
      ...mapGetters([
        'getRole',
        'getYardQc',
        'getMasterDataName',
        'getPermission',
      ]),
      getSelectedItems() {
        return _(this.getItemsToDisplay).filter(it => it.selected);
      },
      getItemsToDisplay() {
        if (this.filterUpdatedToSapFail) {
          return _(this.yardQc).filter(it => it.updatedToSap === false);
        }
        return this.yardQc;
      },
      canConfirm() {
        if (this.getSelectedItems.length === 0) {
          return false;
        }

        if (_(this.getSelectedItems).find(it => it.qcStatus !== 'C' && !it.isChangedToConfirm)) {
          return false;
        }

        return true;
      },
      canReCheck() {
        if (this.getSelectedItems.length === 0) {
          return false;
        }

        if (_(this.getSelectedItems).find(it => it.qcStatus !== 'C' && !it.isChangedToRecheck)) {
          return false;
        }

        return true;
      },
      canSave() {
        return this.getSelectedItems.length > 0;
      },
      canDownload() {
        return this.yardQc.length > 0;
      },
    },
    watch: {
      getYardQc(val) {
        this.updateCachedYardQcFromApi(val);
      },
    },
    mounted() {
      const cachedSearchRequest = this.$store.state.yardQc.searchRequest;
      if (cachedSearchRequest && !_.isEmpty(cachedSearchRequest)) {
        this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
      }

      this.updateCachedYardQcFromApi(this.getYardQc);
    },
    methods: {
      handleAllItemSelectedChanged() {
        _(this.yardQc).each(it => {
          if (it.qcStatus !== "Y") {
            it.selected = this.allItemsSelected;
          }
        })
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header')).offset({ left: -1 * (e.target.scrollLeft - $('.outer-container').offset().left) })
      },
      updateYardQc(yardQc) {
        this.yardQc = yardQc;
      },
      doSearch() {
        this.yardQc = [];
        this.$store.dispatch('loadYardQc', this.searchRequest);
      },
      clearSearch() {
        _(this.$el.querySelectorAll('.searchPanel button.md-input-action.md-clear')).each(it => {
          it.click();
        });
        this.$nextTick(() => {
          this.searchRequest = getInitSearchRequest();
        });
      },
      doConfirm() {
        _(this.getSelectedItems).map(it => {
          if (it.qcStatus !== 'Y') {
            it.qcStatus = 'Y';
            it.isChangedToConfirm = true;
          }else if(it.isChangedToConfirm){
            it.qcStatus = 'C';
            it.isChangedToConfirm = false;
          }
        });
      },
      doReCheck() {
        _(this.getSelectedItems).map(it => {
          if (it.qcStatus !== ' ') {
            it.qcStatus = ' ';
            it.isChangedToRecheck = true;
          }else if(it.isChangedToRecheck){
            it.qcStatus = 'C';
            it.isChangedToRecheck = false;
          }
        });
      },
      doSave() {
        const requests = _(this.getSelectedItems).map(it => {
          const req = {
            loadId: it.loadId,
            problemId: it.problemId,
            moistureBales: it.moistureCount,
            moisturePercentage: it.moisturePercentage,
            downgradeBales: it.downgradeCount,
            downgradeNo: it.grade,
            rebale: it.rebaleCount,
            dispose: it.disposeCount,
            qcStatus: it.qcStatus,
          };
          return this.$store.dispatch('updateYardQc', req)
        });

        Promise.all(requests).then(() => {
          this.doSearch();
        });
      },
      toggleItemPhoto(item) {
        this.currentPictures.downgradeQcPics = item.downgradeQcPics;
        this.currentPictures.moistureQcPics = item.moistureQcPics;
        this.currentPictures.rebalesAndDisposeQcPics = item.rebalesAndDisposeQcPics;
        this.isPictureModalShowing = true;
      },
      updateCachedYardQcFromApi(newYardQc) {
        const yardQc = JSON.parse(JSON.stringify(newYardQc));
        this.updateYardQc(
          _(yardQc).map(it => {
            const photoLinks = _.union(it.downgradeQcPics, it.moistureQcPics, it.rebalesAndDisposeQcPics);
            return _(it).extend(
              {
                selected: false,
                photoLinks: photoLinks,
                canEdit: it.qcStatus === 'C',
                isChangedToRecheck: false,
                isChangedToConfirm: false,
              }
            );
          })
        );
      },
      doDownload() {
        const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'YardQC.xls',
          1,
        );

        request.heads = _(request.heads).take(request.heads.length - 3);
        request.rows = _(this.getItemsToDisplay).map(item => [
          dateFormat.date(item.deliveryEndDate),
          this.getMasterDataName('EndOutlet', item.endOutletId),
          item.loadId,
          item.scaleTicket,
          item.bolNo,
          item.storeId,
          item.moistureCount,
          item.moisturePercentage,
          item.downgradeCount,
          item.grade,
          item.rebaleCount,
          item.disposeCount,
          item.moistureRemark,
          item.downgradeRemark,
          item.rebalesRemark,
          `${item.photoLinks.length} photos`,
          item.qcStatus,
          item.createdBy,
          dateFormat.date(item.createdAt),
          dateFormat.time(item.createdAt),
          item.updatedBy,
          dateFormat.date(item.updatedAt),
          dateFormat.time(item.updatedAt),
        ]);

        this.$store.dispatch('generateExcel', request).then((res) => {
          window.open(res.url, 'blank');
        });
      },
    }
  }
</script>
